import { Injectable } from '@angular/core';
import { RestUtilsService } from 'src/app/service/rest/utils/rest-utils.service';
import { TranslateFirebaseService } from 'src/app/service/utils/translate-firebase.service';
import { Country } from './country.model';

@Injectable()
export class CountryRepositoryService {

  private _countries: Country[] = [];

  countriesLoaded: boolean = false;

  constructor(private utilsRest: RestUtilsService,
    private translate : TranslateFirebaseService) {
    this.loadCountries();
  }

  get countries() : Country[]{
    return this._countries;
  }

  set countries(countries : Country[]){
    this._countries = countries;
  }

  private loadCountries() {
    if(!this.countriesLoaded){
      this.countries = JSON.parse(this.translate.getTranslation('enum_countries'));
      /* this.utilsRest.getCountries()
      .subscribe(result => {
        this.countries = result;
      }, error => {
        console.log(error.status);
      }); */
    }

    this.countriesLoaded = true;
  }

  getTimezone(countryCode : string) : string {
    return this.countries.find(country => countryCode == country.alpha2Code.toLowerCase()).timezones[0];
  }

}
